import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=042d6aa8&"
import script from "./_slug.vue?vue&type=script&lang=ts&"
export * from "./_slug.vue?vue&type=script&lang=ts&"
import style0 from "./_slug.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonBackToParentPage: require('/tmp/build_1fde6b87/src/components/button/BackToParentPage.vue').default,AnimateText: require('/tmp/build_1fde6b87/src/components/animate/AnimateText.vue').default,AdaptiveImageNew: require('/tmp/build_1fde6b87/src/components/media/AdaptiveImageNew.vue').default,BlockHorizontalList: require('/tmp/build_1fde6b87/src/components/block/HorizontalList.vue').default,BlockWorkersHorizontalList: require('/tmp/build_1fde6b87/src/components/block/WorkersHorizontalList.vue').default})
